import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=3169c7c3&"
import script from "./metadata.vue?vue&type=script&lang=ts&"
export * from "./metadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3169c7c3')) {
      api.createRecord('3169c7c3', component.options)
    } else {
      api.reload('3169c7c3', component.options)
    }
    module.hot.accept("./metadata.vue?vue&type=template&id=3169c7c3&", function () {
      api.rerender('3169c7c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/guide/metadata.vue"
export default component.exports